import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IState {
	FirstName: string;
	LastName: string;
	Email: string;
	Roles: number[]
}

// interface dummyKeyPair {
// 	[key: string]: any
// }


const initialState: IState = {
	FirstName: "",
	LastName: "",
	Email: "",
	Roles: [1] //to be chaged later

};

export const adminUserApiSlice = createSlice({
	name: "apiSlice",
	initialState,
	reducers: {
		updateFirstNameAdminUser: (state: any, action: PayloadAction<string>) => {
			state.FirstName = action.payload;
		},
		updateLastNameAdminUser: (state: any, action: PayloadAction<string>) => {
			state.LastName = action.payload;
		},
		updateEmailAdminUser: (state: any, action: PayloadAction<string>) => {
			state.Email = action.payload;
		},
		updateRolesdminUser: (state: any, action: PayloadAction<IState>) => {
			// state.Roles = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const
	{   updateFirstNameAdminUser,
		updateLastNameAdminUser,
		updateEmailAdminUser,
		updateRolesdminUser
	} = adminUserApiSlice.actions;

export default adminUserApiSlice.reducer;
